import Widget                 from "lib/widget"
import AjaxForm               from "servos/ajaxForm";
import $                      from "jquery"
import select2                from "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"
import initDatepicker         from '../../initializers/input_components/datepicker';

class BookInspection extends Widget {
  bind() {
    bindForm.call(this);
  }
}

let bindForm = function() {
  this.formElem = this.root.find('form')
  this.itemSelect = this.root.find(".item-select")
  bindInspectionSelect.call(this);
  bindProjectSearch.call(this)

  this.ajaxForm = new AjaxForm(this.formElem)
  this.ajaxForm.on("success",  success.bind(this))
  this.ajaxForm.on("error",    error.bind(this))
}

let success = function(response) {
  this.formElem.replaceWith(response.data.html);
  bindForm.call(this);
  initDatepicker();

  const modalEl = this.root[0]
  if (modalEl && window.bootstrap && window.bootstrap.Modal) {
    window.bootstrap.Modal.getOrCreateInstance(modalEl).hide()
  }
  swal({
    title: "Booked",
    type: 'success',
    showConfirmButton: false
  })
}

let error = function(response) {
  this.formElem.replaceWith(response.jqXHR.responseJSON.html);
  bindForm.call(this);
  initDatepicker();
}

let requestProjectInspections = function(projectId) {
  $.ajax({
    url: `/projects/${projectId}/inspections`,
    type: "GET",
    dataType: 'json',
    success: (data) => {
      this.root.find('.inspection-items').addClass('d-none')
      this.itemSelect.html("<option value='' >Choose a inspection item</option>")

      _.each(data.inspection_items, (item) => {
        const label = item.inspection_name_label || item.name
        const iso = item.scheduled_at_iso || ''
        this.itemSelect.append(`<option value='${item.id}' ${ item.can_book ? '' : 'disabled'} data-note='${item.note || ''}' data-scheduled-at-iso="${iso}">${_.escape(label)}</option>`)
      })

      this.root.find('.inspection-items').removeClass('d-none')
      this.emit('form-loaded')
    }
  });
}

let bindInspectionSelect = function() {
  this.itemSelect.off('change.bookInspection').on('change.bookInspection', (e) => {
    const selectedOption = $(e.currentTarget).find('option:selected')

    this.root.find('.note').val(selectedOption.data('note'))
    const iso = selectedOption.data('scheduledAtIso') || ''
    const input = this.root.find('.scheduled-at')[0]
    if (input && input._flatpickr) {
      input._flatpickr.setDate(iso || null)
    } else {
      $(input).val(iso)
    }
  })
}

let bindProjectSearch = function() {
  this.projectName = $(this.root.find('.project-search'))
  if (!this.projectName.length) return

  if (this.projectName.data('select2')) {
    this.projectName.select2('destroy')
  }

  this.projectName.select2({
    width: '100%',
    placeholder: 'Search for a project',
    minimumInputLength: 1,
    allowClear: true,
    tags: true,
    theme: 'bootstrap',
    dropdownParent: this.root,
    ajax: {
      url: '/select_data/projects',
      dataType: 'json',
      delay: 250,
      data: (params) => {
        return { by_keyword: params.term }
      },
      processResults: (data, page) => {
        return {
          results: data.collection,
          pagination: data.pagination
        }
      },
      cache: true
    }
  })

  this.projectName.off('select2:select.bookInspection').on('select2:select.bookInspection', (e) => {
    const projectId = e.target.value
    requestProjectInspections.call(this, projectId)
  })
}


export default BookInspection
